<footer class="footer">
    <div class="container">
        <div class="row">
            <div class="col-12">
               {{'madeBy' | translate}} <a href="https://aldawal.com/Home" class="ownerLink" target="_blank"> {{'aldawal' | translate}} </a>
            </div>
        </div>
    </div>
</footer>
